
<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.detail-row {
  display: flex;
  padding: 0 20px;
}
.detail-row .item {
  display: flex;
  flex: 1;
  align-items: center;
}
.detail-row .item .tittle {
  width: 110px;
  text-align: left;
}
.detail-row .item .content {
  width: 500px;
  text-align: left;
}
.detail-row .pdf-container img {
  width: 40px;
  height: 40px;
}
.detail-row .item .pdf-container {
  width: auto;
  text-align: center;
}
.title-grug {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-left: 20px;
}

.title-grug span {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}

.freelist .el-form-item__content {
  /* margin-left: 0 !important; */
}
.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.freelist .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.freelist .el-image {
  visibility: hidden;
}
.freelist .file1 .el-upload--picture-card {
  display: none;
}
.el-image-viewer__wrapper {
  z-index: 99999 !important;
}
.search-area-div {
  width: auto;
} 
</style>
<template>
  <div class="content freelist">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">公司名称 </div>
          <el-input size="mini" v-model="page.tenantName" placeholder="请输入" class="ipt-sty" />
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">公司类型 </div>
          <el-select size="mini" v-model="page.enterpriseCate" placeholder="请选择" class="ipt-sty" clearable>
            <el-option v-for="item in getCodeListByKey('上游客户分类')" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">账号类型 </div>
          <el-select size="mini" v-model="page.memberStatus" placeholder="请选择" class="ipt-sty" clearable>
            <el-option v-for="item in getCodeListByKey('账号类型')" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        
        <el-col :span="6" class="search-btn-box">
          <el-button
              size="mini"
              type="text"
              @click="showMore = !showMore"
              :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            >
              {{ showMore ? "收起筛选" : "更多筛选" }}
            </el-button>
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
          <el-col :span="6"
            ><div class="search-area-div">是否已签合同 </div>
            <el-select
              size="mini"
              v-model="page.isSignContract"
              clearable
              placeholder="请选择"
              class="ipt-sty"
            >
              <el-option
                v-for="item in contractOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            
          </el-col>
          
        </el-row>
    </div>

    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addContract">创建药企</el-button>
      </div>
      <el-table :data="tableData" stripe border tooltip-effect="light" :height="tableHeight" style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" header-align="center" align="center" fixed="left" width="60">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="tenantName" show-overflow-tooltip label="公司名称" header-align="left" align="left" min-width="210px">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>
        <el-table-column prop="abbreviation" show-overflow-tooltip label="公司简称" header-align="left" align="left" min-width="150">
          <template slot-scope="scope">{{ scope.row.abbreviation }}</template>
        </el-table-column>
        <el-table-column prop="enterpriseCate" label="公司类型" header-align="left" align="left"  width="80">
          <template slot-scope="scope">{{  $getNameByKey(scope.row.enterpriseCate, '上游客户分类') }} </template>
        </el-table-column>
        <el-table-column prop="contacts" label="业务联系人" header-align="left" align="left"  width="90">
          <template slot-scope="scope">{{scope.row.contacts }}</template>
        </el-table-column>
        <el-table-column prop="contactTel" label="联系电话" header-align="left" align="left"  width="100">
          <template slot-scope="scope">{{scope.row.contactTel}}</template>
        </el-table-column>
        <el-table-column prop="accountCycle" label="核算周期" header-align="left" align="left"  width="100">
          <template slot-scope="scope">{{scope.row.accountDeadline |accountType }}</template>
        </el-table-column>
        <el-table-column prop="memberStatus" label="账号类型" header-align="left" align="left"  width="80">
          <template slot-scope="scope">{{scope.row.memberStatus|memberType }}</template>
        </el-table-column>

        <!-- <el-table-column prop=" tenantNote" show-overflow-tooltip label="企业简述" header-align="left" align="left" width="150">
          <template slot-scope="scope">{{ scope.row.tenantNote || '-' }}</template>
        </el-table-column> -->
        <!-- <el-table-column prop="initUserName" label="超管帐号" header-align="left" align="left" width="120">
          <template slot-scope="scope">{{ scope.row.initUserName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="supertubeFlag" label="账户性质" header-align="left" align="left" width="120">
          <template slot-scope="scope">{{scope.row.supertubeFlag == 'Y' ? '超级管理' : '普通管理'}}</template>
        </el-table-column> -->
        <el-table-column prop="isSignContract" label="是否合同签订" header-align="left" align="left"  width="100">
          <template slot-scope="scope">
            <span v-show="scope.row.isSignContract=='Y'">
              已签订
            </span>
            <span v-show="scope.row.isSignContract=='N'">
              未签订
            </span>
            
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="left" align="left" width="145">
          <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" fixed="right" align="center" width="160">
          <template slot-scope="scope">
            <a class="txt-color" @click="editContract(scope.row)">编辑｜</a>
            <a class="txt-color" @click="delContract(scope.row.guid)">删除 | </a>
            <!-- <a class="txt-color" @click="addMenus(2, scope.row)">初始化菜单｜</a> -->
            <a class="txt-color" @click="getSales(scope.row)">分配服务商</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50,100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="40%">
      <div v-if="dialogVisible">
  
        <el-form label-width="130px" :label-position="right" class="demo-ruleForm">
          <div class="title-grug"><span></span>基本信息</div>
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">公司名称 </span>
            <el-input class="fl" placeholder="请输入" v-model.trim="tenantName"> </el-input>
          </el-form-item>
          <el-form-item>
            <!-- <span slot="label" style="color: red">*</span> -->
            <span slot="label">公司简称 </span>
            <el-input class="fl" placeholder="请输入" v-model.trim="abbreviation"> </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">公司类型 </span>
            <el-select v-model="enterpriseCate" placeholder="请选择" class="fl w100f">
              <el-option v-for="item in getCodeListByKey('上游客户分类')" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">会员状态</span>
            <el-select v-model="memberStatus" placeholder="请选择" class="fl w100f">
              <el-option v-for="item in memberStatusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label" style="color: red"> </span>
            <span slot="label">企业地址 </span>
            <el-cascader
            ref="cascaderFirst"
            v-model="addressList"
            :options="options" class="fl w100f" @change="incres" ></el-cascader>
          </el-form-item>
          <el-form-item>
            <span slot="label" style="color: red"> </span>
            <span slot="label">详细地址 </span>
            <el-input class="fl" placeholder="请输入"  v-model.trim="formData.address" type="textarea"
              :rows="2"  maxlength="50"> </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label" style="color: red"> </span>
            <span slot="label">联系人 </span>
            <el-input class="fl" placeholder="请输入" @input="formData.contacts=formData.contacts.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g,'')" v-model.trim="formData.contacts" maxlength="10"> </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label" style="color: red"> </span>
            <span slot="label">联系电话 </span>
            <el-input class="fl" placeholder="请输入" @input="formData.contactTel=formData.contactTel.replace(/[^\d\-\d]/g,'')" v-model.trim="formData.contactTel" maxlength="11"> </el-input>
          </el-form-item>
          <el-form-item label="企业简述">
            <el-input
              class="fl" 
              type="textarea"
              :rows="5" 
              placeholder="最多可输入200个字"
              v-model="tenantNote"
            >
            </el-input>
            </el-form-item>
            <!-- <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">账户性质 </span>
            <el-select v-model="supertubeFlag" placeholder="请选择" class="fl w100f" v-if="enterpriseCate == '9901'">
              <el-option v-for="item in supertubeFlagListC" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="supertubeFlag" placeholder="请选择" class="fl w100f" v-else>
              <el-option v-for="item in supertubeFlagList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">账号角色 </span>
            <el-input class="fl" placeholder="请输入" v-model="initRoleName" :disabled="true"> </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">初始帐号 </span>
            <el-input
              class="fl"
              :maxlength="11"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              placeholder="请输入"
              v-model="initUserName"
              :disabled="textTitle == '编辑企业'"
            >
            </el-input>
          </el-form-item> -->
          <el-form-item label="营业执照">
            <el-upload
              action="#"
              name="image"
              class="fl"
              list-type="picture-card"
              :headers="token"
              :limit="1"
              accept=".jpg,.png,.jpeg"
              :on-exceed="handleExceedYYZZ"
              :file-list="fileListYYZZ"
              :on-remove="handlePdfRemoveYYZZ"
              :http-request="uploadPdfYYZZ"
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <div style="color: #999; text-align: left; margin-left: 80px; margin-bottom: 20px">
            说明：最大不超过 5M 的图片
          </div>
          <el-form-item label="企业LOGO">
            <el-upload
              action="#"
              name="image"
              class="fl"
              list-type="picture-card"
              :headers="token"
              :limit="1"
              accept=".jpg,.png,.jpeg"
              :on-exceed="handleExceedLOGO"
              :file-list="fileListLOGO"
              :on-remove="handlePdfRemoveLOGO"
              :http-request="uploadPdfLOGO"
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <div style="color: #999; text-align: left; margin-left: 80px; margin-bottom: 20px">
            说明：最大不超过 5M，底部透明的png图片，用于移动端首页
          </div>
          <el-form-item label="背景图">
            <el-upload
              action="#"
              name="image"
              class="fl"
              list-type="picture-card"
              :headers="token"
              :limit="1"
              accept=".jpg,.png,.jpeg"
              :on-exceed="handleExceedBG"
              :file-list="fileListBG"
              :on-remove="handlePdfRemoveBG"
              :http-request="uploadPdfBG"
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <div style="color: #999; text-align: left; margin-left: 80px; margin-bottom: 20px">
            说明：最大不超过 5M 的图片，用于移动端“我的”背景图
          </div>
          <template v-if="enterpriseCate=='010201'">
            <div class="title-grug"><span></span>系统对接信息</div>
            <el-form-item>
                <!-- <span slot="label" style="color: red">*</span> -->
                <span slot="label">系统对接方式</span>
                <div style="display:flex;flex-direction:column;text-align: left;">
                  <el-radio  style="margin-bottom:10px" v-model="tenantConfig.syncMethod" label="1">方式一、ERP系统中业务员与业务数据有绑定关系</el-radio>
                  <el-radio  v-model="tenantConfig.syncMethod" label="2">方式二、ERP系统中业务员与业务数据无绑定关系</el-radio>
                </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" style="color:white">*</span>
              <span slot="label">执行间隔</span>
              <span style="display:flex;">
                在业务时间的后<el-input style="width:50px;margin:0 5px;" v-model="tenantConfig.allocateDayAfter"  :maxlength="2" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>天
              </span>
            </el-form-item>
        </template>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" plain @click="dialogVisible = false">取 消</el-button>
          <el-button
            size="mini"
            type="info"
            v-if="textTitle == '新增药企'"
            @click="addReqVersion"
            v-loading.fullscreen.lock="fullscreenLoading"
            >确 定</el-button
          >
          <el-button
            size="mini"
            type="info"
            v-else
            @click="updateReqVersion"
            v-loading.fullscreen.lock="fullscreenLoading"
            >修 改</el-button
          >
        </span>
      </div>
    </el-dialog>

    <!-- 添加菜单权限 -->
    <el-dialog
      :title="textTitle1"
      :visible.sync="dialogFormVisible"
      width="650px"
      @close="clearDialog"
      style="margin-bottom: 0"
    >
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" :label-position="right" class="demo-ruleForm">
        <!-- <el-form-item label="角色名称:" prop="roleName">
          <el-input v-model="ruleForm.roleName" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <el-form-item label="显示顺序:" prop="orderNum">
          <el-input v-model="ruleForm.orderNum" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="状态:" class="t-left">
          <el-radio v-model="ruleForm.bizState" label="Y">有效</el-radio>
          <el-radio v-model="ruleForm.bizState" label="S">停用</el-radio>
        </el-form-item> -->
        <el-form-item label="应用产品:" class="t-left" style="margin-bottom: 0">
          <div class="borderR6 border-4f">
            <template>
              <el-checkbox-group v-model="productGuidList">
                <el-checkbox
                  class="mb16"
                  @change="changePro(product)"
                  v-for="product in productList"
                  :key="product.guid"
                  :label="product.guid"
                  border
                  size="small"
                >
                  <span :class="activeProduct == product.guid ? 'check-txt fontC-4fa1a4' : 'check-txt'">{{
                    product.productName
                  }}</span>
                  <!-- <span :class="activeProduct==product.guid?'fontC-4fa1a4':''" @click.prevent="changePro(product)">{{product.productName}}</span> -->
                  <!-- {{ product.productName }} -->
                </el-checkbox>
              </el-checkbox-group>
            </template>
            <el-tree
              v-if="isTreeShow"
              :data="currentProduct.menus"
              show-checkbox
              node-key="guid"
              ref="tree"
              :expand-on-click-node="false"
              :props="defaultProps"
              @check-change="handleNodeCilck"
              :check-strictly="checkStrictly"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span
                  >{{ data.menuName }} <span class="remark-class" v-if="data.remark">（{{ data.remark }}）</span></span
                >
              </span>
              <!-- @check-change="handleNodeCilck" -->
              <!--  :default-checked-keys="ids" -->
              <!-- :check-strictly="isCheck" -->
            </el-tree>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="clearDialog()">取消</el-button>
        <el-button size="mini" type="info" @click="submitMenus('ruleForm')" v-loading.fullscreen.lock="fullscreenLoading">确定</el-button>
        <!-- <el-button size="mini" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button> -->
      </div>
    </el-dialog>
 
    <!-- 添加省 -->
    <el-dialog title="区域范围" :visible.sync="dialogVisibleProvince" width="40%" :before-close="close">
      <el-button size="mini" class="fr mb15" type="info" @click="addArea">添加</el-button>
      <el-table
        :data="areaRangeList"
        :key="Math.random()"
        style="width: 100%">
        <el-table-column
          prop="date"
          label="运营方名称">
          <template slot-scope="scope">
            <el-select filterable v-model="scope.row.serviceTenantGuid" placeholder="请选择" @change="getTenantBusinessAreaRange(scope.$index,scope.row.serviceTenantGuid)">
              <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
         <!-- v-if="scope.row.areaDataOptions != null && scope.row.areaDataOptions.length > 0" -->
        <el-table-column
          prop="name"
          label="业务地域范围">
          <template slot-scope="scope">
          <el-cascader
            :options="scope.row.areaDataOptions"
            v-model="scope.row.areaRangeList"
            style="width: 100%"
            :props="{ multiple: true}"
            clearable
            collapse-tags
          ></el-cascader>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="操作" width="90" header-align="right" align="right">
          <template slot-scope="scope">
          <a class="txt-color" @click="delArea(scope.$index,scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="区域范围:">
          
        </el-form-item>
      </el-form> -->
      <span slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="dialogVisibleProvince = false">取消</el-button>
        <el-button size="mini" type="info" @click="getProvince">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  data() {
    return {
      tableHeight: window.innerHeight - 280,
      contentMainHeight: window.innerHeight - 180,
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      
      supertubeFlagListC: [
        { value: 'Y', label: '超级管理' },
        { value: 'N', label: '普通管理' },
      ],
      supertubeFlagList: [
        { value: 'N', label: '普通管理' },
      ],
      contractOptions: [
        {
          value: "Y",
          label: "已签订",
        },
        {
          value: "N",
          label: "未签订",
        },
      ],
      supertubeFlag:'',
      initRoleName:'数据管理员',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        enterpriseCate: null,
        memberStatus: null,//账号类型
        isSignContract: '',//合同签订状态
        // enterpriseCates: [],
      },
      enterpriseCate: '0101',
      memberStatus:'',
      tenantName: '',
      tenantNote: '',
      initUserName: '',
      abbreviation: '',

      fullscreenLoading: false,
      textTitle: '新增药企',
      textTitle1: '设置菜单',
      dialogVisible: false,
      dialogVisible1: false,
      guid: '',
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',

      url: `/ms-common-admin-cloud-service//obs/upload-file`,
      urlImg: `/ms-common-admin-cloud-service//obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      fileListYYZZ: [], //营业执照
      fileListLOGO: [], //企业LOGO
      fileListBG: [], //背景图
      licenseGuid: '',
      formData:{
        province:null,
        city:null,
        district:null,
        contacts:null,
        contactTel:null,
        venue:null
      },
      dialogFormVisible: false,
      tree: '',
      ruleForm: {
        tenantGuid: '',
        platformGuid: '',
        appSideGuid: '',  
        menuGuids: '',
        tenantGuid: '',
      },
      productGuidList: [],
      productList: [],
      isTreeShow: true,
      checkStrictly: false,
      currentProduct: {},
      defaultProps: {
        id: 'guid',
        label: 'menuName',
        children: 'children',
      },
      rules: {},
      dialogVisibleProvince:false,
      activeProduct: '',
      options: areaJson,
      areaData:[],
      ids:[], 
      areaRangeList:[{
        guid:'',
        sendTenantGuid:'',
        serviceTenantGuid:'',
        areaRangeList:[],
        areaDataOptions:[],
      }],
      operationRelList:[],
      tenantList:[],
      updateTenant:{
        guid:'',
        tenantGuid:'',
        sendTenantGuid:'',
        serviceTenantGuid:'',
        areaRangeList:[],
      },
      serviceTenantGuidList:[],
      //正式会员 ZSHY ；演示会员 YSHY；试用会员 SYHY
      memberStatus:'',
      memberStatusList: [{
        value:'ZSHY',
        label:'正式会员'
      }, {
        value:'YSHY',
        label:'演示会员'
      }, {
        value:'SYHY',
        label:'试用会员'
      }],
      tenantConfig:{
        tenantGuid:'',
        syncMethod:'',
        allocateDayAfter:'',
      },
      addressList:[]//地址编码
    };
  },
  filters:{
    memberType(val) {
      let objStr = {
        SYHY: '试用会员',
        YSHY: '演示会员',
        YXHY: '意向会员',
        ZSHY: '正式会员',
      };
      return objStr[val] || '-';
    },
    
    // accountType(val) {
    //   let str=''
    //   if(val.accountCycle=='核算月'){
    //     str="每月"+val.accountDeadline+"日截止"
    //   }else{
    //     str=val.accountCycle
    //   }
      
    //   return str || '-';
    // },
    accountType(val) {
      let str=''
      if(!val){
        str='-'
      }else if(val==0){
        str='自然月'
        
      }else{
        str="每月"+val+"日截止"
      }
      return str ;
    },
  },
  created() {
    this.getList();
  },
  watch: {
    activeProduct(val) {
      console.log(val);
      this.currentProduct = this.productList.find((k) => k.guid === val) || {};
      console.log(this.currentProduct);
      this.refreshTree();
    },
    payMonth(newVal) {
      if (!newVal) return;
      var newVal = newVal + '-01';
      var self = this;
      self.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area?date=` +
            newVal +
            '&tenantGuid=' +
            this.currentCompanyGuid,
        )
        .then((resp) => {
          self.startEndTime = resp.data.data.replace(',', '至');
        });
    },
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 330;
        this.contentMainHeight = window.innerHeight - 230;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 280;
        this.contentMainHeight = window.innerHeight - 180;
        return;
      }
    
    },
  },
  methods: {
    incres(area) {
      const checkedNodes = this.$refs['cascaderFirst'].getCheckedNodes()
      let arr = checkedNodes[0].pathNodes
      let codeArr = []
      arr.forEach(item => {
        codeArr.push(item.data.value)
      }) 
      this.formData.province = codeArr[0];
      this.formData.city = codeArr[1];
      this.formData.district = codeArr[2]; 
      let venue = '';
      if(codeArr){
        if (codeArr[0]) {
          venue = this.province(codeArr[0]);
        }
        if (codeArr[1]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]);
        }
        if (codeArr[2]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]) + '/' + this.district(codeArr[2]);
        }
      }
      this.formData.venue = venue;
    },
    province(val) {
      let pr = '';
      this.options.forEach(function (j) {
        if (j.value == val) {
          pr = j.label;
        }
      });
      return pr;
    },
    city(val) {
      let ci = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.value == val) {
              ci = j.label;
            }
          });
        }
      });
      return ci;
    },
    district(val) {
      let di = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.children != null && j.children != '') {
              j.children.forEach(function (n) {
                if (n.value == val) {
                  di = n.label;
                }
              });
            }
          });
        }
      });
      return di;
    },
    getSales(row){
      let self = this;  
      self.updateTenant.tenantGuid = self.$store.state.guid;
      self.updateTenant.sendTenantGuid = row.guid;
      self.areaRangeList = [];
      self.serviceTenantGuidList = [];
      self.getTenantList(); 
      self.getTenantOperationRelList(row.guid);  
      setTimeout(function(){
        self.dialogVisibleProvince = true;
      },1000)
    },
    getTenantOperationRelList(guid){
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`,{'tenantGuid':guid,'isService':false}).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.areaRangeList = res.data.data;
          if(self.areaRangeList != null && self.areaRangeList.length > 0){
            self.areaRangeList.forEach(async(i,index)=>{ 
              let list = [];
              if(i.areaRangeList != null && i.areaRangeList.length > 0){
                i.areaRangeList.forEach((j)=>{
                  list.push([j.province,j.city]);
                })
              }
              i.areaRangeList = list; 
              await self.getTenantBusinessAreaRange1(index,i.serviceTenantGuid);
              self.serviceTenantGuidList.push(i.serviceTenantGuid); 
            })
          }else{
            self.areaRangeList = [];
          }
          console.log('明细',self.areaRangeList);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTenantList() {
      let self = this; 
      
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`,{'pageIndex':1,'pageSize':-1,'enterpriseCates':['9901','9904']}).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;  
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    // 分配服务商查询服务商
    getTenantBusinessAreaRange1(index,guid) {
      var self = this;   
      self.areaRangeList[index].areaDataOptions = []; 
      let itemAll = [];
      let itemAllList = [];
      return new Promise((resolve)=>{
        self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-business-area-range?tenantGuid=`+guid).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
            let data = res.data.data;  
            if(data != null && data.length > 0){
              // self.areaData = [];
              data.forEach((i)=>{
                if(i.venue != null && i.venue != ''){
                  let item = {
                    value:i.province,
                    label:i.venue.split('/')[0]
                  }
                  console.log(item); 
                    itemAll.push(item); 
                } 
              })
              let noRepeat = [...new Set(itemAll.map(item => JSON.stringify(item)))];
              itemAllList = noRepeat.map(item => JSON.parse(item)) 
              if(itemAllList != null){
                itemAllList.forEach((j,idn)=>{
                    j.children = self.getAreaChildren(j.label,data);
                    if(itemAllList.length - 1 == idn){
                      console.log(itemAllList.length,idn);
                      self.areaRangeList[index].areaDataOptions = itemAllList;
                      console.log('获取药企区域',index,self.areaRangeList);
                    }
                })
              }
              resolve()
            }else{
              self.areaData = [];
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
      });
    },
    getTenantBusinessAreaRange(index,guid) {
      var self = this; 
      this.$nextTick(()=>{
        console.log('存在',guid,self.serviceTenantGuidList);
        if(self.serviceTenantGuidList != null && self.serviceTenantGuidList.length > 0){ 
          if(self.serviceTenantGuidList.indexOf(guid) != -1){
            self.$message.error('运营方已存在!'); 
            self.areaRangeList[index].serviceTenantGuid = '';
            self.serviceTenantGuidList.splice(index,1);
            return 
          }else{
            if(self.serviceTenantGuidList[index]){
              self.serviceTenantGuidList.splice(index,1);
              self.serviceTenantGuidList.push(guid); 
            }else{
              self.serviceTenantGuidList.push(guid); 
            }
          }
        }else{
          self.serviceTenantGuidList.push(guid);
        }
        console.log('存在All',self.serviceTenantGuidList);
        self.areaRangeList[index].areaDataOptions = []; 
        let itemAll = [];
        let itemAllList = [];
        return new Promise((resolve)=>{
          self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-business-area-range?tenantGuid=`+guid).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
              let data = res.data.data;  
              if(data != null && data.length > 0){
                // self.areaData = [];
                data.forEach((i)=>{
                  if(i.venue != null && i.venue != ''){
                    let item = {
                      value:i.province,
                      label:i.venue.split('/')[0]
                    } 
                    itemAll.push(item); 
                  } 
                })
                let noRepeat = [...new Set(itemAll.map(item => JSON.stringify(item)))];
                itemAllList = noRepeat.map(item => JSON.parse(item)) 
                if(itemAllList != null){
                  itemAllList.forEach((j,idn)=>{
                      j.children = self.getAreaChildren(j.label,data);
                      if(itemAllList.length-1 == idn){
                        console.log(itemAllList.length,idn);
                        self.areaRangeList[index].areaDataOptions = itemAllList;
                        console.log('获取药企区域',index,self.areaRangeList);
                      }
                  })
                } 
                resolve()
              }else{
                self.areaData = [];
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
      }) 
    },
    getAreaChildren(lab,data){
      let self = this; 
      let child = [];
      if(data != null){
        data.forEach((i)=>{ 
          if(i.venue && lab === i.venue.split('/')[0]){
            let item = {
              value:i.city,
              label:i.venue.split('/')[1]
            }
            child.push(item);
          }
        })
      }
      return child ? child :[];
    },
    getProvince(){
      let self = this;
      if(self.areaRangeList != null && self.areaRangeList.length > 0){ 
        self.updateTenantBusinessAreaRange();
      }else{
        // self.$message.error('请选择运营方添加范围！');
        // return
        self.dialogVisibleProvince = false
      }
    },
    updateTenantBusinessAreaRange(){
      let self = this; 
      let operationRel = [];
      console.log('aaaaaa',self.areaRangeList);
      self.areaRangeList.forEach((i)=>{
        let promise = [];
        let venue = '';
        if(i.areaRangeList != null && i.areaRangeList.length > 0){
          i.areaRangeList.forEach((d)=>{
            self.options.forEach(function (j) {
              if (d[0] == j.value) {
                venue = j.label;
              }
            });
            if(d[1]){ 
              self.options.forEach(function (j) {
                if (d[0] == j.value) {
                  if(j.children != null && j.children != ''){
                    j.children.forEach(function(k){ 
                      if(d[1] == k.value){
                        venue = j.label + '/' + k.label;
                      } 
                    })
                  }
                }
              }); 
            }
            let item = {
              province:d[0],
              city:d[1],
              venue:venue
            }
            promise.push(item);
          }) 
        } 
        let upList = {
          guid:i.guid,
          tenantGuid:self.updateTenant.tenantGuid,
          sendTenantGuid:self.updateTenant.sendTenantGuid,
          serviceTenantGuid:i.serviceTenantGuid,
          areaRangeList:promise
        }
        operationRel.push(upList);
      })
      console.log('oooooooooo',operationRel);
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/update-tenant-operation-rel`,operationRel)
      .then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisibleProvince = false;
          self.$message.success('区域范围设置成功！');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //清空弹窗内容
    clearDialog() {
      this.productGuidList = [];
      this.allMenuList = [];
      this.$refs['ruleForm'].resetFields();
      this.dialogFormVisible = false;
    },
    refreshTree() {
      this.isTreeShow = false;
      this.$nextTick(() => {
        // 重新渲染菜单树节点
        this.isTreeShow = true;
        this.$nextTick(() => {
          this.$refs.tree && this.$refs.tree.setCheckedKeys(this.currentProduct.checkedKeys || []);
        });
      });
    },
    changePro(val) {
      this.activeProduct = val.guid;
    },
    handleNodeCilck(node, checked, data) {
      // let self = this;
      this.currentProduct.checkedKeys = this.$refs.tree.getCheckedKeys();
      console.log(this.currentProduct.checkedKeys);
      // self.checkStrictly = false
      // if(checked == false){
      //   self.currentProduct.checkedKeys.forEach((i,index)=>{
      //     if(node.guid == i){
      //       this.currentProduct.checkedKeys.splice(index,1)
      //     }
      //   })
      // }
      // this.$refs.tree.getHalfCheckedKeys() 选中子节点也选中父节点
      // let tree = this.$refs.tree;
      // let ss = tree.getCheckedKeys().concat(self.menuGuidList).concat(tree.getHalfCheckedKeys());
      // self.menuGuidList = [...new Set(ss)];
    },
    close() {
      this.dialogVisible = false;
      this.dialogVisibleProvince = false;
    },
    addMenus(flg, row) {
      let self = this;
      self.getAllProduct();
      if (flg == 2) { 
        self.ruleForm.initRoleGuid = row.initRoleGuid;
        self.ruleForm.tenantGuid = row.guid; 
        self.menuGuidList = [];
        // self.getDataDetail(row.initRoleGuid);
        self.getTenantMenu(row.guid);
      }
      self.dialogFormVisible = true;
      // if (flg == 1) {
      //   //弹窗显示后才能获取到refs的树节点
      //   setTimeout(function () {
      //     self.$refs.tree.setCheckedKeys([]); //给树节点赋值
      //   }, 200);
      // }
    },
    // getDataDetail(guid) {
    //   let self = this;
    //   if (guid == null || guid == '') {
    //     return;
    //   }
    //   self.ids = [];
    //   // self.checkStrictly = true
    //   self.api.get(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/get-detail?guid=` + guid).then((res) => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       self.activeProduct = res.data.data.productGuid ? res.data.data.productGuid[0] : '';
    //       self.productGuidList = res.data.data.productGuid ? res.data.data.productGuid : []; 
    //       self.roleDetailData = res.data.data.children || [];
    //       self.roleDetailData.forEach(function (i) {
    //         if (i.children) {
    //           i.children.forEach(function (j) {
    //             if (self.ids.indexOf(j.guid) == -1) {
    //               self.ids.push(j.guid);
    //             }
    //           });
    //         } else {
    //           self.ids.push(i.guid);
    //         }
    //       });
    //       self.menuGuidList = self.ids;
    //       self.isCheck = true; //重点：给数节点赋值之前 先设置为true
    //       self.$nextTick(() => {
    //         //因为我是根据数据id来判断选中所以使用setCheckedKeys，具体可以查看element官网api
    //         // self.$refs.tree.setCheckedKeys(self.menuGuidList); //给树节点赋值

    //         self.isCheck = false; //重点： 赋值完成后 设置为false
    //       });
    //       // setTimeout(()=>{

    //       // },2000)
    //       this.$nextTick(() => {
    //         self.getAllMenu();
    //       });
    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    // },
    getTenantMenu(guid) {
      let self = this;
      if (guid == null || guid == '') {
        return;
      }
      self.ids = [];
      // self.checkStrictly = true
      self.api.get(`/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-tenant-menu?tenantGuid=` + guid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.activeProduct = res.data.data.productGuid ? res.data.data.productGuid[0] : '';
          self.productGuidList = res.data.data.productGuid ? res.data.data.productGuid : []; 
          self.roleDetailData = res.data.data.children || [];
          self.roleDetailData.forEach(function (i) {
            self.ids.push(i.guid);
            if (i.children) {
              i.children.forEach(function (j) {
                if (self.ids.indexOf(j.guid) == -1) {
                  self.ids.push(j.guid);
                }
              });
            }
          });
          self.menuGuidList = self.ids;
          console.log(self.menuGuidList);
          self.isCheck = true; //重点：给数节点赋值之前 先设置为true
          self.$nextTick(() => {
            //因为我是根据数据id来判断选中所以使用setCheckedKeys，具体可以查看element官网api
            // self.$refs.tree.setCheckedKeys(self.menuGuidList); //给树节点赋值

            self.isCheck = false; //重点： 赋值完成后 设置为false
          });
          // setTimeout(()=>{

          // },2000)
          this.$nextTick(() => {
            self.getAllMenu();
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAllProduct() {
      let self = this;
      self.productList = [];
      self.activeProduct = ''; 
      self.api
        .postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/product/data/get`, {
          platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
          pageIndex: 1,
          pageSize: -1,
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.productList = res.data.data.records;
            self.productGuid = self.productList[1].guid;
            if(self.textTitle1 == '新增角色'){ 
              self.getAllMenu(this.productList);
            }
            console.log(this.productList);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    }, 
    getAllMenu() {
      let self = this;
      const AllPromises = (this.productList || []).map((product) => {
        let promise = {
          guid: '',
          parentGuid: '',
          platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
          productGuid: [product.guid],
        };
        return new Promise((resolve) => {
          self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get`, promise).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.allMenuList = res.data.data;
              product.menus = res.data.data;
              product.checkedKeys = self.menuGuidList.filter((k) => {
                const hasNodeByGuid = (guid, tree) => {
                  // 判断树中有guid
                  return tree.find((item) => {
                    return item.guid === guid || hasNodeByGuid(guid, item.children || []);
                  });
                };
                return hasNodeByGuid(k, product.menus);
              });
              // self.menuGuidList = self.ids;
              // self.allMenuList.forEach((item) => {
              //   item.menuName = item.remark ? item.menuName + '（' + item.remark + '）': '（'+item.menuName + '）'; //菜单名+标签
              //   if (item.children) {
              //     item.children.forEach((oneData) => {
              //       oneData.menuName = oneData.remark ? oneData.menuName + '-' + oneData.remark : oneData.menuName ; //菜单名+标签
              //     });
              //   }
              // });
              resolve(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
      });
      Promise.all(AllPromises).then((res) => {this.refreshTree();})
    },
    getNodeByGuid(guid, tree) {
      let node;
      tree.forEach((k) => {
        if (k.guid === guid) {
          node = k;
        } else if (k.children) {
          k.children.forEach((j) => {
            if (j.guid === guid) {
              node = j;
            }
          });
        }
      });
      return node;
    },
    submitMenus(formName){
      let self = this; 
      if(self.productList != null && self.productList.length > 0){
        self.upDateForm(formName);
      }else{
        self.deleteMenus();
      }
    },
    deleteMenus() {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          var req = [self.ruleForm.tenantGuid];
          self.tableLoading = true;
          self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/delete-tenant-menu`, req).then((res) => {
            self.tableLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    upDateForm(formName) {
      let self = this; 
      self.$refs[formName].validate((valid) => {
        if (valid) {
          const menuGuids = self.productList
            .reduce((total, next) => {
              const arr = (next.checkedKeys || [])
                .map((guid) => {
                  const node = self.getNodeByGuid(guid, next.menus) || {};
                  return node.parentGuid ? node.parentGuid + '-' + node.guid : node.guid;
                })
                .join('-')
                .split('-');
              return [...total, ...arr];
            }, [])
            .filter((k) => k);
          let promise = { 
            tenantGuid:self.ruleForm.tenantGuid, 
            menuGuids: [...new Set([...menuGuids])],
          };
          //
          console.log(promise.menuGuids);
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/update-tenant-menu`, promise).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.fullscreenLoading = false;
              self.menuGuidList = [];
              self.$message.success('编辑角色成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    getDataDetail(guid) {
      let self = this;
      if (guid == null || guid == '') {
        return;
      }
      self.ids = [];
      // self.checkStrictly = true
      self.api.get(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/get-detail?guid=` + guid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.activeProduct = res.data.data.productGuid ? res.data.data.productGuid[0] : '';
          self.productGuidList = res.data.data.productGuid ? res.data.data.productGuid : [];
          // self.roleDetailData = res.data.data.children || [];
          // self.roleDetailData.forEach(function (i) {
          //   if (i.children) { //匹配一级
          //     i.children.forEach(function (j) {
          //       if(j.children){  //匹配二级
          //         j.children.forEach(item=>{
          //           if(item.children){  //匹配三级

          //           }else{
          //             self.ids.push(item.guid)
          //           }
          //         })
          //       }else{
          //         self.ids.push(j.guid)
          //       }
          //     });
          //   } else {
          //     self.ids.push(i.guid);
          //   }
          // });
          // self.menuGuidList = self.ids;
          self.isCheck = true; //重点：给数节点赋值之前 先设置为true
          self.$nextTick(() => {
            //因为我是根据数据id来判断选中所以使用setCheckedKeys，具体可以查看element官网api
            // self.$refs.tree.setCheckedKeys(self.menuGuidList); //给树节点赋值

            self.isCheck = false; //重点： 赋值完成后 设置为false
          });
          // setTimeout(()=>{

          // },2000)
          this.$nextTick(() => {
            self.getAllMenu();
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    preview(srcList) {
      this.srcList = [];
      var srcList = JSON.parse(srcList);
      srcList.forEach((item) => {
        this.srcList.push(item.url);
      });
      this.$forceUpdate();
      this.showViewer = true;
      // setTimeout(()=>{
      //   this.$refs.preview.clickHandler()
      // },300)
    },

    search() {
      var self = this;
      self.page.pageIndex = 1;
      self.tableLoading = true;
      self.page.enterpriseCateList =self.page.enterpriseCate? [self.page.enterpriseCate]:this.$getValueListByKey('上游客户分类');
      self.page.memberStatusList = self.page.memberStatus?[self.page.memberStatus]:[];
      let currentTenantGuid=localStorage.guid
      
      let req={
        currentTenantGuid,
        ...self.page,

      }
      console.log(self.page,'serch');
      // tenant/data/get
      self.api.postJson('/ms-customer-service/tenant-expand/get-medicine-enterprise', req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        enterpriseCate: null,
        memberStatus:null,
        isSignContract:'',//是否签订合同
        // enterpriseCates: [],
      };
      this.getList();
    },
    addPath() {
      this.$router.push({
        path: '/addDrugCompanies',
        query: { tenantGuid: this.ruleForm.tenantGuid, productGuid: this.$route.query.productGuid }
      });
    },
    editPath(guid) {
      this.$router.push({
        path: '/addDrugCompanies',
        query: { guid: guid, tenantGuid: this.ruleForm.tenantGuid, productGuid: this.$route.query.productGuid }
      });
    },
    addContract() {
      this.addPath()
    },
    editContract(res) {
      this.editPath(res.guid)
    }, 
    getList() {
      var self = this;
      self.tableLoading = true;
      self.page.enterpriseCateList =self.page.enterpriseCate? [self.page.enterpriseCate]: this.$getValueListByKey('上游客户分类');
      let currentTenantGuid=localStorage.guid
      
      let req={
        currentTenantGuid,
        ...self.page,
        

      }
      console.log('getList',);
      
      // tenant/data/get
      // tenant-expand/get-medicine-enterprise
      self.api.postJson('/ms-customer-service/tenant-expand/get-medicine-enterprise', req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    addArea(){
      let item = {
        guid:'',
        sendTenantGuid:'',
        serviceTenantGuid:'',
        areaRangeList:[],
        areaDataOptions:[],
      }
      this.areaRangeList.push(item);
    },
    delArea(index,guid){
      var self = this;
      self.areaRangeList.splice(index,1);
      self.serviceTenantGuidList.splice(index,1);
      if(guid){
        if(self.serviceTenantGuidList){
          self.serviceTenantGuidList.forEach((i,idn)=>{
            if(i == guid){
              self.serviceTenantGuidList.splice(idn,1);
            }
          })
        }
        self.deleteTenantBusinessAreaRange(guid);
      }
    },
    deleteTenantBusinessAreaRange(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/delete-tenant-operation-rel`,[guid]).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              // self.dialogVisibleProvince = false;
              self.$message.success('删除成功');
              // self.page.pageIndex = 1;
              // self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    delContract(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          var req = [guid];
          self.tableLoading = true;
          // tenant/data/delete
          self.api.postJson(`/ms-customer-service/tenant-expand/del-medicine-enterprise`, req).then((res) => {
            self.tableLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    addReqVersion() {
      if (!this.tenantName) {
        this.$message.error('请填写公司名称');
        return;
      }
      if (!this.memberStatus) {
        this.$message.error('请选择会员状态');
        return;
      }
      // if(this.enterpriseCate=='010201'){
      //   if(!this.tenantConfig.syncMethod){
      //     this.$message.error('请选择系统对接方式');
      //   }
      // }
      var self = this;
      var req = {
        tenantName: this.tenantName,
        tenantNote: this.tenantNote,
        enterpriseCate: this.enterpriseCate,
        initUserName: this.initUserName,
        abbreviation: this.abbreviation,
        initRoleName: this.initRoleName,
        supertubeFlag: this.supertubeFlag,
        appSideGuid: '',
        backgroundUrl: this.fileListBG.length != 0 ? JSON.stringify(this.fileListBG) : null,
        pictContent: this.fileListLOGO.length != 0 ? JSON.stringify(this.fileListLOGO) : null, 
        platformGuid: '',
        memberStatus:this.memberStatus,
        tenantConfig:this.enterpriseCate=='010201'?this.tenantConfig:null,//系统对接方式
        province:self.formData.province,
        city:self.formData.city,
        district:self.formData.district,
        address:self.formData.address,
        contacts:self.formData.contacts,
        contactTel:self.formData.contactTel,
        venue:self.formData.venue
        
      };
      if (this.fileListYYZZ.length != 0) {
        req.tenantLicAddDTOs = [
          {
            licenseNum: '0000',
            licenseType: '1',
            pictContent: JSON.stringify(this.fileListYYZZ),
            isUnlimited: 'N',
            beginDate: '',
            endDate: '',
            guid: '',
          },
        ];
      }
     req.platformGuid = '1e2409b7ef0b412c2bb84e38f8fe50ba';
     if (location.href.indexOf('https://scm-operation.csyaoly.com/')>-1) {
        req.appSideGuid = 'f2cb03a2b3e84149df939753f9825054';
      }else{
        req.appSideGuid = 'f2cb03a2b3e84149df939753f9825054';
      }
      self.fullscreenLoading = true;

      self.api.postJson(`/ms-customer-service/tenant/data/add`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      if (!this.tenantName) {
        this.$message.error('请填写公司名称');
        return;
      }
      if (!this.memberStatus) {
        this.$message.error('请选择会员状态');
        return;
      }
      // if(this.enterpriseCate=='010201'){
      //   if(!this.tenantConfig.syncMethod){
      //     this.$message.error('请选择系统对接方式');
      //   }
      // }
      var self = this;
      var req = {
        guid: this.guid,
        tenantName: this.tenantName,
        tenantNote: this.tenantNote,
        enterpriseCate: this.enterpriseCate,
        initUserName: this.initUserName,
        abbreviation: this.abbreviation,
        initRoleName: this.initRoleName,
        supertubeFlag: this.supertubeFlag,
        appSideGuid: '',
        backgroundUrl: this.fileListBG.length != 0 ? JSON.stringify(this.fileListBG) : null,
        pictContent: this.fileListLOGO.length != 0 ? JSON.stringify(this.fileListLOGO) : null,
        appSideGuid: '',
        platformGuid: '',
        memberStatus:this.memberStatus,
        tenantConfig:this.enterpriseCate=='010201'?this.tenantConfig:null,//系统对接方式
        province:self.formData.province,
        city:self.formData.city,
        district:self.formData.district,
        address:self.formData.address,
        contacts:self.formData.contacts,
        contactTel:self.formData.contactTel,
        venue:self.formData.venue

      };
      if (this.fileListYYZZ.length != 0) {
        req.tenantLicUpdateDTOs = [
          {
            licenseNum: '0000',
            licenseType: '1',
            pictContent: JSON.stringify(this.fileListYYZZ),
            isUnlimited: 'N',
            beginDate: '',
            endDate: '',
            guid: this.licenseGuid,
          },
        ];
      } else {
        req.tenantLicUpdateDTOs = null;
      }
     req.platformGuid = '1e2409b7ef0b412c2bb84e38f8fe50ba';
     if (location.href.indexOf('https://scm-operation.csyaoly.com/')>-1) {
        req.appSideGuid = 'f2cb03a2b3e84149df939753f9825054';
      }else{
        req.appSideGuid = 'f2cb03a2b3e84149df939753f9825054';
      }
      self.fullscreenLoading = true;
      self.api.put(`/ms-customer-service/tenant/data/update`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    handleExceedBG(files, filePdfAttachList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleExceedLOGO(files, filePdfAttachList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleExceedYYZZ(files, filePdfAttachList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handlePdfRemoveBG(file) {
      let self = this;
      self.fileListBG.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.fileListBG.splice(ind, 1);
        }
      });
    },
    handlePdfRemoveLOGO(file) {
      let self = this;
      self.fileListLOGO.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.fileListLOGO.splice(ind, 1);
        }
      });
    },
    handlePdfRemoveYYZZ(file) {
      let self = this;
      self.fileListYYZZ.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.fileListYYZZ.splice(ind, 1);
        }
      });
    },
    uploadPdfBG(file) {
      let self = this;
      let is5M = file.file.size / 1024 / 1024 < 5; // 限制小于5M
      // console.log(file.file.size,is5M);
      if (!is5M) {
        this.fileListBG.splice(this.fileListYYZZ.length,1); 
        self.$message.error('大小不可超过5MB');
        return
      }
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '背景',
              url: res.data.data,
            };
            self.fileListBG.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    uploadPdfLOGO(file) {
      let self = this;
      let is5M = file.file.size / 1024 / 1024 < 5; // 限制小于5M
      // console.log(file.file.size,is5M);
      if (!is5M) {
        this.fileListLOGO.splice(this.fileListYYZZ.length,1); 
        self.$message.error('大小不可超过5MB');
        return
      }
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '企业LOGO',
              url: res.data.data,
            };
            self.fileListLOGO.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    uploadPdfYYZZ(file) {
      let self = this;
      let is5M = file.file.size / 1024 / 1024 < 5; // 限制小于5M
      // console.log(file.file.size,is5M);
      if (!is5M) {
        this.fileListYYZZ.splice(this.fileListYYZZ.length,1); //营业执照
        self.$message.error('大小不可超过5MB');
        return
      }
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '营业执照',
              url: res.data.data,
            };
            self.fileListYYZZ.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
  },
};
</script> 
<style scoped>

/deep/ .el-dialog__body {
    padding: 15px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  /* display: none; */
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
.check-txt {
    display: inline-block;
    width: 72px;
    line-height: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0px;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.el-col-6{
  display: flex;
  /* margin-bottom: 10px; */
}
.search-area-div {
  width: 100px;
  /* text-align: right; */
}
.ipt-sty{
  /* flex: 1; */
  width: 70% !important;
  margin-left: 5px;
}
</style>